module.exports = __webpack_public_path__ + "static/media/trademark-svg.557f71fe.svg";